module.exports = __webpack_public_path__ + "static/media/19-STIs.ad1313d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/19-STIs.jpg
// module id = 153
// module chunks = 0